<template>
  <div>
    <div class="row mb-5">
      <span class="display-4 col-12">
        {{ `${categoryEquipment.name}` }} -
        {{ $t("COMMON.LOGS") }}
      </span>
    </div>

    <log-list-table :filterSubject="categoryEquipment" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "category-equipment-view-logs",

  components: { LogListTable },

  props: ["categoryEquipment"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
